import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";

const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ crs, handleCancelClick, increment, counter, setCrsId }) => {
  const [newCrs, setNewCrs] = useState(crs);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewCrs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "course/" + newCrs.id + "/",
          newCrs,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setCrsId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={newCrs.title}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="length"
          className="form-control"
          id="length"
          value={newCrs.length}
          placeholder=""
          onChange={handleChange}
        />
      </td>

      <td>
        <input
          type="date"
          name="start_date"
          className="form-control"
          id="start_date"
          value={newCrs.start_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="date"
          name="end_date"
          className="form-control"
          id="end_date"
          value={newCrs.end_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="education_frame"
          className="form-control"
          id="education_frame"
          value={newCrs.education_frame}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="certifcate"
          className="form-control"
          id="certifcate"
          value={newCrs.certifcate}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
